import React, {useEffect, useState, useRef, useCallback} from 'react';
import {
    Box,
    Button,
    useToast,
    VStack,
    Text,
    useDisclosure,
    Stack,
    Heading,
    Flex,
    Container,
    useColorModeValue,
    Icon,
    useBreakpointValue,
    InputGroup,
    Tooltip,
    Image,
    InputLeftAddon,
    InputRightAddon,
    Input,
    HStack,
    Badge,
    Link,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    SimpleGrid,
    Avatar,
} from '@chakra-ui/react';
import axios from 'axios';
import DocumentGrid from './DocumentGrid';
import {createThumbnail} from '../../utils/pdf-page-helpers';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../redux/AuthProvider';
import { useDispatch, useSelector } from 'react-redux';
import {
    addDocument,
    addVideo,
    setOneVideo,
    removeDocument,
    setCurrentChatInput,
    setDocuments,
    setIsPricingModalOpen,
    setIsUploadLoading,
    setScanError,
    setScanEstimatedSeconds,
    setScanFileID,
    setVideos,
    setDocumentsGeneration,
    setAudiobooks, setScanType, addAudiobook, setOutlineInAudiobook, addAudioInAudiobook
} from '../../redux/reducers';
import {addDocumentInStorage, addVideoToStorage, getDocumentsInStorage} from '../../utils/local-storage-helpers';
import {influencerMap, SERVER_IP, SERVER_IP_VIDEO} from "../../utils/constants";
import {useDropzone} from "react-dropzone";
import { motion } from 'framer-motion';
import SignUpScreen1 from "../../components/Modals/SignUp/SignUpScreen1";
import SignInScreen1 from "../../components/Modals/SignIn/SignInScreen1";
import LargeWithNewsletter from "../../components/Reuseable/LargeWithNewsletter";
import LoadingBar from "./LoadingBar";
import FullScreenTemplateHomePage from "../../templates/FullScreenTemplateHomePage";
import {
    FcAddImage,
    FcDocument, FcLock, FcMultipleInputs, FcQuestions, FcReading, FcSportsMode, FcViewDetails,
} from 'react-icons/fc'
import ReactPlayer from "react-player/lazy";
import LazyLoad from 'react-lazyload';
import lightTheme from "../../utils/styles";
import {fetchAudiobooks, fetchDocuments, fetchVideos} from "../../utils/redux-helpers";
import ScanModal1 from "../../components/Modals/Scans/ScanModal1";
import ScanModalIntro1 from "../../components/Modals/Scans/ScanModalIntro1";
import WithSpeechBubbles from "./WithSpeechBubbles";
import PricingScreen from "../../components/Modals/Payments/PricingScreen";
import '../../fonts.css';
import {useTranslation} from "react-i18next";
import LogoCarousel2 from "../../components/Reuseable/LogoCarousel2";
import URLInput from "./URLInput";
import DocumentGridVideos from "./DocumentGridVideos";
import DocumentGridGeneration from "./DocumentGridGeneration";
import DocumentGridGenerationEmpty from "./DocumentGridGenerationEmpty";
import DocumentGridVideosEmpty from "./DocumentGridVideosEmpty";
import TwoColumnLayout from "./TwoColumnLayout";
import BigTestimonial from "./BigTestimonial";
import DocumentGridEmpty from "./DocumentGridEmpty";
import {initializeMultidoc} from "../../utils/multi-doc-helpers";
import {fetchMultidocs} from "../../utils/multi-doc-helpers";
import {useServerIP} from "../../redux/ServerIPContext";
import DocumentGridAudiobooks from "./DocumentGridAudiobooks";
import DocumentGridAudiobooksEmpty from "./DocumentGridAudiobooksEmpty";
import {createAudiobook} from "../../utils/audiobook-helpers";
import { ContainerTextFlip } from "../../components/ui/container-text-flip";
import {
  initiateMultipartUpload,
     uploadMultipartParts,
  completeMultipartUpload
} from '../../utils/multipartUpload';
import {
    initiateMultipartUploadPDF,
    uploadMultipartPartsPDF,
    completeMultipartUploadPDF
} from '../../utils/multipartUploadPDF';
import {DocumentGridMembers} from "./DocumentGridMembers";
import DocumentGridMembersEmpty from "./DocumentGridMembersEmpty";
import {FileIcon} from "../../components/Reuseable/FileIcon";
import LogoCarousel3 from "../../components/Reuseable/LogoCarousel3";
import {FiEdit3, FiFileText, FiHeadphones, FiMusic, FiPlay, FiSearch, FiVideo} from "react-icons/fi";
import TypingAnimation from "../../components/Reuseable/TypingAnimation";
import FAQ2 from "../Payments/FAQ2";
import {failedPDFNotification} from "../../utils/api";
import {seoConfigs, updatePageSEO} from "../../utils/seo-helpers";

// import localForage from 'localforage';
//
// // Configure localForage to use your application's name and store name
// localForage.config({
//     name: 'MyApp',
//     storeName: 'thumbnails', // name of the datastore
// });
const MotionBox = motion(Box);

// next up. Add audiobooks here from top to bottom
const NewUnifiedHomePage = () => {
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    const {t} = useTranslation();
    const featuresRef = useRef(null);
    const testimonialsRef = useRef(null);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const fileInput = useRef();
    const fileInputAudiobook = useRef();
    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenScanModal1, onOpen: onOpenScanModal1, onClose: onCloseScanModal1 } = useDisclosure();
    const { isOpen: isOpenScanModalIntro1, onOpen: onOpenScanModalIntro1, onClose: onCloseScanModalIntro1 } = useDisclosure();
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();
    const isUploadLoading = useSelector(state => state.settings.isUploadLoading);
    const [uploadProgress, setUploadProgress] = useState(0);
    const auth = useAuth();
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm';
    const fileInputVideo = useRef();

    useEffect(() => {
        updatePageSEO(seoConfigs.home);
        console.log(localStorage.getItem("email"))

        if (JSON.parse(localStorage.getItem("isProPlan"))) {
            console.log("I AM ON THE PRO PLAN");
        }
    }, []);

    const navigateToTestimonials = () => {
        if (testimonialsRef.current) {
            const offsetTop = testimonialsRef.current.getBoundingClientRect().top + window.pageYOffset;
            const offset = 50; // The amount of pixels you want to stop above the element
            window.scrollTo({ top: offsetTop - offset, behavior: 'smooth' });
        }
    }

    const navigateToFeatures = () => {
        if (featuresRef.current) {
            const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset;
            const offset = 50; // The amount of pixels you want to stop above the element
            window.scrollTo({ top: offsetTop - offset, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const hash = window.location.hash.substring(1);
        if (hash) {
            if (hash === 'features' && featuresRef.current) {
                const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 160, behavior: 'smooth' });
            } else if (hash === 'testimonials' && testimonialsRef.current) {
                const offsetTop = testimonialsRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 140, behavior: 'smooth' });
            }
        }
    }, []);

    // WTFFFFFFFFFFFFFFFFFFFF
    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab === 'videos') {
            setTabIndex(2); // Set Videos tab active
        } else if (tab === 'multidoc') {
            setTabIndex(1); // Set Multidoc tab active
        } else if (tab === 'audiobooks') {
            setTabIndex(3); // Set Audio tab active
        } else if (tab === 'members') {
            setTabIndex(4); // Set Members tab active
        } else if (tab === 'bigquery') {
            setTabIndex(5); // Set BigQuery tab active
        }
        else {
            setTabIndex(0); // Default to PDFs tab
        }
    }, [searchParams]);

    const handleTabChange = (index) => {
        if (index === 0) {
            setSearchParams({ tab: 'pdfs' });
        } else if (index === 1) {
            setSearchParams({ tab: 'multidoc' });
        } else if (index === 2) {
            setSearchParams({ tab: 'videos' });
        } else if (index === 3) {
            setSearchParams({ tab: 'audiobooks' });
        } else if (index === 4) {
            setSearchParams({ tab: 'members' });
        } else if (index === 5) {
            setSearchParams({ tab: 'bigquery' });
        }
        // setSearchParams({ tab: index === 0 ? 'pdfs' : 'videos' }); // Update URL with query parameter
    };

    const onDropAudiobook = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            handleFileUpload({target: {files: [file]}}, true).then(r => {
                navigate('/?tab=audiobooks');
            });
        }
    }, []);
    const {
        getRootProps: getRootPropsAudiobook,
        getInputProps: getInputPropsAudiobook,
        isDragActive: isDragActiveAudiobook
    } = useDropzone({
        onDrop: onDropAudiobook, // Correctly assign the function
        accept: 'application/pdf',
        multiple: false,
    });

    const onDrop = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            handleFileUpload({target: {files: [file]}}, false).then(r =>{
                navigate('/?tab=pdfs');
            });
        }
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'application/pdf',
        multiple: false,
    });

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const videoProgress = async (progress_key) => {
        while (true) {
            try {
                console.log("CALLING GENERAL_PROGRESS with key:", progress_key);
                const response = await axios.post(serverIPs.SERVER_IP + "/general_progress", {
                    key: progress_key
                });
                console.log("GENERAL_PROGRESS response:", response);
                // Resolve only if the message is not one of the waiting messages.
                // if (response.data.message !== "Starting to transcribe video" &&
                //     response.data.message !== "key not found") {
                //     return response.data.message;
                // } else if (response.data.message === "Finished transcribing video") {
                //     return response.data.message;
                // }
                if (response.data.message === "Finished transcribing video") {
                    return response.data.message;
                }
            } catch (error) {
                console.error("Error in general_progress", error);
            }
            // Wait for 5 seconds before retrying.
            await sleep(5000);
        }
    };

    const startProgressTimer = () => {
        const interval = setInterval(() => {
            setUploadProgress(prevProgress => {
                if (prevProgress < 99) {
                    // Get a random increment between 1 and 4 (inclusive)
                    const randomIncrement = Math.floor(Math.random() * 4) + 1;
                    const newProgress = Math.min(prevProgress + randomIncrement, 99);
                    return newProgress;
                } else {
                    clearInterval(interval);
                    return prevProgress;
                }
            });
        }, 3800);
        return interval;
    };


    const handleMP4Upload = async (event) => {
        dispatch(setIsUploadLoading(true));
        const file = event.target.files[0];
        // if (!file || file.type !== "video/mp4") return;

        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload mp4 or mp3 files",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            return;
        }

        // const formData = new FormData();
        // formData.append("data_type", "file");
        // formData.append("user_id", localStorage.getItem("userID"));
        try {
            // console.log("/videos/get_file_upload_url payload", {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // })
            // const firstResponse = await axios.post(serverIPs.SERVER_IP + '/videos/get_file_upload_url', {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // });
            // console.log("firstResponse", firstResponse);
            // setUploadProgress(10);
            // const progressInterval = startProgressTimer();
            //
            // const secondResponse = await axios.put(firstResponse.data.message.presigned_url, file, {
            //     headers: {
            //         'Content-Type': 'application/mp4'
            //     }
            // });
            //
            // if (secondResponse.status === 200) {
            //     console.log('PDF uploaded successfully AWS!', secondResponse);
            //     setUploadProgress(24);
            // } else {
            //     console.error('Failed to upload PDF AWS:', secondResponse.statusText);
            // }
            // formData.append("file_id", firstResponse.data.message.file_id)
            // clearInterval(progressInterval);
            // const response = await axios.post(serverIPs.SERVER_IP + '/videos/video', formData, {
            //     onUploadProgress: (progressEvent) => {
            //         console.log("Progress Event", progressEvent);
            //         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            //         setUploadProgress(percentCompleted);
            //     }
            // });
            // console.log('Uploaded BWC VIDEO Response:', response);
            // 1️⃣  INITIATE
            const { file_id, presigned_urls } = await initiateMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file.name,
                file.size
            );
                setUploadProgress(2);

            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
            const etagValues = await uploadMultipartParts(
                file,
                presigned_urls,
                (percent) => setUploadProgress(percent)
            );

            // 3️⃣  COMPLETE
            await completeMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file_id,
                etagValues
            );
            setUploadProgress(100);

            // 4️⃣  Tell your backend to begin processing
            const formData = new FormData();
            formData.append("data_type", "file");
            formData.append("user_id", localStorage.getItem("userID"));
            formData.append("file_id", file_id);

            if (file.type === "audio/mpeg") {
                formData.append("file_type", "mp3");
            }

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);

            const response = await axios.post(
                `${serverIPs.SERVER_IP}/videos/video`,
                formData,
                {
                    onUploadProgress: ev => {
                        const pct = Math.round((ev.loaded * 100) / ev.total);
                        setUploadProgress(pct);
                    }
                }
            );

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            if (response.data.status === 400 && response.data.message.message === "video transcription started") {
                dispatch(addVideo({
                    id: response.data.message.file_id,
                    name: file.name,
                    url: response.data.message.video_presigned_url,
                    thumbnail_url: "",
                    isLongLoading: true,
                    highlights: [],
                    messages: [],
                    messagesGeneration: [],
                }));
                await videoProgress(response.data.message.polling_progress_key);
            }

            console.log("ADD VIDEO", response.data.message.video_presigned_url);
            dispatch(setOneVideo({
                id: response.data.message.file_id,
                name: file.name,
                url: response.data.message.video_presigned_url,
                thumbnail_url: "",
                isLongLoading: false,
                highlights: [],
                messages: [],
                messagesGeneration: [],
            }));
            toast({
                title: t("Video uploaded."),
                status: "success",
                duration: 9000,
                isClosable: true,
            });
            navigate("/?tab=videos");
        } catch (error) {
            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            toast({
                title: t('Oops, this video failed.'),
                description: t('Please try again or upload a different video.'),
                status: "error",
                duration: 9000,
                isClosable: true,
            })
            console.error('Error uploading the video:', error);
        }
    };


    // Define the upload function based on the user authentication state
    const handleFileUpload = async (event, isAudiobook) => {
        console.log("USERID BELOW: ")
        //console.log(localStorage.getItem("userID"));

        const document = event.target.files[0];
        if (localStorage.getItem("userID") !== null) {
            if (document) {
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    // const formData = new FormData();
                    // formData.append('file', document);
                    // formData.append('user_id', localStorage.getItem("userID"));
                    // formData.append('file_name', document.name);

                    try {
                        // 1️⃣  INITIATE
                        let response;
                        const initiateResponse = await initiateMultipartUploadPDF(
                            serverIPs.SERVER_IP,
                            localStorage.getItem("userID"),
                            document.name,
                            document.size
                        );
                        if (initiateResponse === "File size is under 10MB") {
                            const formData = new FormData();
                            formData.append('file', document);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);
                            response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                                onUploadProgress: (progressEvent) => {
                                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    setUploadProgress(percentCompleted);
                                }
                            });
                        } else {
                            const file_id = initiateResponse.file_id;
                            const presigned_urls = initiateResponse.presigned_urls;
                            setUploadProgress(2);

                            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                            const etagValues = await uploadMultipartPartsPDF(
                                document,
                                presigned_urls,
                                (percent) => setUploadProgress(percent)
                            );

                            // 3️⃣  COMPLETE
                            await completeMultipartUploadPDF(
                                serverIPs.SERVER_IP,
                                localStorage.getItem("userID"),
                                file_id,
                                etagValues
                            );
                            setUploadProgress(100);

                            // 4️⃣  Tell your backend to begin processing
                            const formData = new FormData();
                            formData.append('file_id', file_id);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);

                            response = await axios.post(
                                `${serverIPs.SERVER_IP}/pdf`,
                                formData,
                                {
                                    onUploadProgress: ev => {
                                        const pct = Math.round((ev.loaded * 100) / ev.total);
                                        setUploadProgress(pct);
                                    }
                                }
                            );
                            // setUploadProgress(0);
                            // dispatch(setIsUploadLoading(false));
                        }
                        console.log('Uploaded PDF Document Response:', response);
                        // export const createAudiobook = async (file_id, user_id, serverIP, toast) => {
                        if (isAudiobook && response.data.status !== 207) {
                            // kicks off an async job.
                            console.log("create_audiobook_clicked");
                            createAudiobook(response.data.file_id, localStorage.getItem("userID"), serverIPs.SERVER_IP, toast).then(r => {
                                // at this point the new upload is on the grid view. Either call /start_session right automatically or wait for
                                // the user to click on the grid item
                                console.log("createAudiobook response", r);
                                // dispatch(setOutlineInAudiobook({documentID: response.data.file_id, outline: r.outline}));
                                // [{
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 1",
                                // }, {
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 2",
                                // }]

                            });
                        }


                        if (response.data.status === 207) {
                            if (isAudiobook) {
                                dispatch(setScanType("audiobook"));
                            } else {
                                dispatch(setScanType("normal"));
                            }
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            if (isAudiobook) {
                                dispatch(addAudiobook({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                            } else {
                                dispatch(addDocument({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                            }
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        } else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), 
                                document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                            console.log("pricing_modal_shown")
                            dispatch(setIsPricingModalOpen(true));
                            localStorage.setItem("isUploadExceeded", "true");
                            toast({
                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                status: "info",
                                duration: 9000,
                                isClosable: true,
                                position: "top",
                            });
                        }
                        else if (response.data.status === 402 && response.data.message === "PDF is corrupted, try uploading a different PDF") {
                            toast({
                                title: t("Oops, this PDF has corrupted bytes or is malformed"),
                                description: t("Please try again. (Or try converting it to DOCX and back to PDF and upload that new PDF)"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit honeybear.ai/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 200 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            if (isAudiobook) {
                                console.log("add audiobook here");
                                dispatch(addAudiobook({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                                toast({
                                    title: t("Uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            } else {
                                dispatch(addDocument({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                                toast({
                                    title: t("Document uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            }
                        }
                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    toast({
                        title: t("Single-Upload only supports PDFs"),
                        description: t("Click the 'Multi-Upload' tab at the top to upload other file types"),
                        status: "error",
                        duration: 20000,
                        isClosable: true,
                    })
                }
            }
        } else {
            if (document) {
                if (getDocumentsInStorage().length === 1) {
                    toast({
                        title: t("You've reached your document limit in guest mode!"),
                        description: t("Please sign up to continue uploading documents."),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    onOpenSignUpScreen1()
                    return;
                }
                if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                    toast({
                        title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    dispatch(setIsPricingModalOpen(true));
                    return;
                }
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    const formData = new FormData();
                    formData.append('file', document);
                    formData.append('user_id', "11111111-1111-1111-1111-111111111111");
                    formData.append('file_name', document.name);
                    try {
                        const response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(percentCompleted);
                            }
                        });



                        if (response.data.status === 207) {
                            dispatch(setScanType("normal"));
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            dispatch(addDocument({
                                id: response.data.message.file_id,
                                name: response.data.message.filename,
                                url: response.data.message.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        } else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit honeybear.ai/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 200 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            addDocumentInStorage({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            })
                            auth.setPlaygroundDocuments(getDocumentsInStorage());
                            dispatch(addDocument({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            toast({
                                title: t("Document uploaded."),
                                status: "success",
                                duration: 9000,
                                isClosable: true,
                            })
                        }

                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    toast({
                        title: t("Single-Upload only supports PDFs"),
                        description: t("Click the 'Multi-Upload' tab at the top to upload other file types"),
                        status: "error",
                        duration: 20000,
                        isClosable: true,
                    })
                }
            }
        }
    };

    const handleYoutubeLinkUpload = async (url) => {
        console.log("YOUTUBE URL", url);
        if (localStorage.getItem("userID") !== null) {
            if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                toast({
                    title: t("(Free Plan) Video Upload Limit Exceeded!"),
                    status: "info",
                    duration: 9000,
                    isClosable: true,
                    position: "top",
                });
                dispatch(setIsPricingModalOpen(true));
                return;
            }
            // toast({
            //     title: "Sorry, YouTube videos are not working at the moment.",
            //     description: "Google has changed their API and we are working on a fix. Please try again later.",
            //     status: "error",
            //     duration: 10000,
            //     isClosable: true,
            // })
            // return;
            dispatch(setIsUploadLoading(true));
            const formData = new FormData();
            formData.append('yt_link', url);
            formData.append('data_type', "yt_link");
            formData.append('user_id', localStorage.getItem("userID"));

            // console.log("video input", {
            //     yt_link: url,
            //     data_type: "yt_link",
            //     user_id: localStorage.getItem("userID"),
            // })
            try {
                const response = await axios.post(serverIPs.SERVER_IP_VIDEO + '/videos/video', formData, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    }
                });
                console.log('Uploaded Video Response new:', response);
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                if (response.data.status === 400 && (response.data.message === "Invalid YouTube link" || response.data.message === "Invalid video ID")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Invalid YouTube link"),
                        description: t("Please enter a valid YouTube link"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message === "YouTube request failed") {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Upload Failed"),
                    //     description: t("Please try again or upload a different video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message === "Video unavailable") {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Video is unavailable"),
                    //     description: t("Please make sure it's not a private video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && (response.data.message === "No transcript available"
                    || response.data.message === "No transcript found" || response.data.message === "Transcript is None for some reason")) {
                    console.log("encoded url", encodeURIComponent(url));
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: "Video Upload Succeeded",
                    //     description: "",
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error getting transcript:")) {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Please try again!"),
                    //     description: t("If the issue persists, please try a different video as this video may not have a transcript"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error: ")) {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Please try again!"),
                    //     description: t("If the issue persists, please try a different video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400
                    && response.data.message === "Video transcript too big, try working with a smaller video") {
                    console.log("video_upload_error")
                    toast({
                        title: t("Video too large"),
                        description: t("Please try a shorter length video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                    console.log("pricing_modal_shown")
                    dispatch(setIsPricingModalOpen(true));
                    localStorage.setItem("isUploadExceeded", "true");
                    toast({
                        title: t("(Free Plan) Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                }
                else {
                    console.log("video_upload_success")
                    dispatch(addVideo({
                        id: response.data.file_id,
                        name: response.data.filename,
                        url: response.data.url,
                        thumbnail_url: response.data.thumbnail_presigned_url,
                        highlights: [],
                        messages: [],
                        messagesGeneration: [],
                    }));
                    toast({
                        title: t("Video uploaded."),
                        status: "success",
                        duration: 9000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                addVideoToStorage(url)
                navigate(`/youtube/${encodeURIComponent(url)}`);
                console.log("video_upload_error")
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                // toast({
                //     title: t("Oops, this Video Upload failed."),
                //     description: t("Please try again or upload a different video."),
                //     status: "error",
                //     duration: 9000,
                //     isClosable: true,
                // })
                console.error('Error uploading the video:', error);
            }
        }
        // else {
        //         if (getDocumentsInStorage().length === 1) {
        //             toast({
        //                 title: t("You've reached your document limit in guest mode!"),
        //                 description: t("Please sign up to continue uploading documents."),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             onOpenSignUpScreen1()
        //             return;
        //         }
        //         if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
        //             toast({
        //                 title: t("(Free Plan) PDF Upload Limit Exceeded!"),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             dispatch(setIsPricingModalOpen(true));
        //             return;
        //         }
        //         dispatch(setIsUploadLoading(true));
        //         try {
        //             const response = await axios.post(SERVER_IP + '/videos/video', {
        //                 yt_link: url,
        //                 data_type: "yt_link",
        //                 user_id: "11111111-1111-1111-1111-111111111111",
        //             }, {
        //                 onUploadProgress: (progressEvent) => {
        //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //                     setUploadProgress(percentCompleted);
        //                 }
        //             });
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             if (response.data.status === 400) {
        //                 toast({
        //                     title: t("PDF is too large."),
        //                     description: t("We support up to 512 MB or 147,000 words"),
        //                     status: "error",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //             else {
        //                 addDocumentInStorage({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 })
        //                 auth.setPlaygroundDocuments(getDocumentsInStorage());
        //                 dispatch(addVideo({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail_url: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 }));
        //                 toast({
        //                     title: t("Video uploaded."),
        //                     status: "success",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //
        //         } catch (error) {
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             toast({
        //                 title: t("Oops, this PDF failed."),
        //                 description: t("Please try again or upload a different PDF."),
        //                 status: "error",
        //                 duration: 9000,
        //                 isClosable: true,
        //             })
        //             console.error('Error uploading the document:', error);
        //         }
        // }
    }

    // Select the correct document list based on authentication
    const documents = useSelector(state => state.documents.savedDocuments);
    const videos = useSelector(state => state.documents.savedVideos);
    const generations = useSelector(state => state.documents.savedGenerations);
    const audiobooks = useSelector(state => state.documents.savedAudiobooks);

    // CHANGE THIS FOR VIDEOS LATER
    useEffect(() => {
        const tempUserID = localStorage.getItem("userID");

        if (tempUserID !== null) {
            // Get the current search parameters
            // const currentSearchParams = new URLSearchParams(window.location.search);
            // const currentTab = currentSearchParams.get('tab');

            // // Decide navigation based on the user's entered path or default
            // if (currentTab === 'videos') {
            //     navigate('/?tab=videos'); // Stay on videos
            //     setTabIndex(2);
            // } else if (currentTab === 'multidoc') {
            //     navigate('/?tab=multidoc'); // Stay on multidocs
            //     setTabIndex(1);
            // } else if (currentTab === 'pdfs' || currentTab === null) {
            //     // Default to PDFs if no `tab` query or explicitly `tab=pdfs`
            //     navigate('/?tab=pdfs');
            //     setTabIndex(0);
            // }

            // Fetch documents and videos
            fetchDocuments(tempUserID, serverIPs.SERVER_IP).then(r => {
                dispatch(setDocuments(r.documents));
            });
            fetchVideos(tempUserID, serverIPs.SERVER_IP_VIDEO).then(r => {
                dispatch(setVideos(r.videos));
            });
            fetchMultidocs(tempUserID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                dispatch(setDocumentsGeneration(r.multidocs));
            });
            fetchAudiobooks(tempUserID, serverIPs.SERVER_IP).then(r => {
                dispatch(setAudiobooks(r.audiobooks));
            });
        }
    }, []);


    const placeholders = ["https://www.youtube.com/watch?v=aJwdWeiSc8c",
        "https://www.youtube.com/watch?v=nyOD7m4uOv8"];
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholders[0]);
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true); // State to manage fade in and out
    const [urlInput, setUrlInput] = useState("");

    useEffect(() => {
        const intervalId = setInterval(() => {
            setFade(false); // Fade out the current placeholder

            setTimeout(() => {
                // After fade out, change the placeholder and fade it in
                setIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
                setCurrentPlaceholder(placeholders[index]);
                setFade(true);
            }, 750); // Half the interval time to allow for fade in and fade out
        }, 1500);

        return () => clearInterval(intervalId);
    }, [index]);

    const handleSubmit = () => {
        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload YouTube videos",
                description: "Then you can chat with them just like with normal PDFs!",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
        } else {
            setUrlInput("");
            handleYoutubeLinkUpload(urlInput).then(r => {
                setUrlInput("")
                // navigate('/?tab=videos');
            });
        }
    };

    const [tabIndex, setTabIndex] = useState(0);
    const [workspaceLoading, setWorkspaceLoading] = useState(false);
    const areAllFilesEmpty = (...fileArrays) => {
        return fileArrays.every(fileArray => fileArray.length === 0) && !auth.isLoggedIn;
    };

    const isAnyFileNonEmpty = (...fileArrays) => {
        return fileArrays.some(fileArray => fileArray.length !== 0);
    };

    const renderTabContent = () => {
        if (tabIndex === 0) {
            return documents.length !== 0 ? (
                <DocumentGrid navigate={navigate} />
            ) : (
                <DocumentGridEmpty />
            );
        }

        if (tabIndex === 1) {
            return generations.length !== 0 ? (
                <DocumentGridGeneration navigate={navigate} />
            ) : (
                <DocumentGridGenerationEmpty />
            );
        }

        if (tabIndex === 2) {
            return videos.length !== 0 ? (
                <DocumentGridVideos navigate={navigate} />
            ) : (
                <DocumentGridVideosEmpty />
            );
        }

        if (tabIndex === 4) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }

        if (tabIndex === 5) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }

        if (tabIndex === 3) {
            return audiobooks.length !== 0 ? (
                <DocumentGridAudiobooks navigate={navigate} />
            ) : (
                <DocumentGridAudiobooksEmpty />
            );
        }

        return null; // Default case if tabIndex is not 0, 1, or 2
    };

    const phrases = [
        "What is the main argument of this document? Respond in Spanish.",
        "Give a detailed summary of the entire document.",
        "Which quotes are most relevant in supporting my thesis statement?"
    ];

    return (
        <div>
            <FullScreenTemplateHomePage navigateToTestimonials={navigateToTestimonials} navigateToFeatures={navigateToFeatures}>
                <VStack width={'100%'} height={'100%'} justifyContent={'center'} display={'flex'} spacing={'4rem'}
                        mt={areAllFilesEmpty(documents, videos, generations, audiobooks) ? '3.5rem' : '0rem'}>
                    {isAnyFileNonEmpty(documents, videos, generations, audiobooks) || auth.isLoggedIn ?
                        isUploadLoading ?
                            <Box width={'60%'} pt={'3.5rem'}>
                                <LoadingBar progress={uploadProgress} isMarginBottom={true}/>
                            </Box> :
                            <VStack width={"100%"} height={'21.75rem'} mb={'1rem'} spacing={6} py={'1.75rem'}
                                    bg={lightTheme.colors.lightGray}>
                                <VStack
                                    width={{
                                        base: '88%',
                                        sm: '70%',
                                        md: '60%',
                                        lg: '55%',
                                        xl: '50%',
                                    }}
                                    bg={'white'}
                                    height={'18rem'}
                                    borderRadius={'15px'}
                                    spacing={4}
                                    borderColor={'lightgray'}
                                    borderWidth={0.25}
                                    shadow={`1.5px 1.8px 0px lightgray`}
                                    position="relative"
                                >
                                    <Tabs
                                        variant="soft-rounded"
                                        colorScheme="orange"
                                        onChange={handleTabChange}
                                        index={tabIndex}
                                        width="100%"
                                        position="absolute"
                                        top="0rem"
                                        left="0rem"
                                        zIndex={1}
                                    >
                                        <TabList>
                                            <Tab borderTopLeftRadius={'15px'}
                                                 borderTopRightRadius={'0px'}
                                                 borderBottomRadius={'0px'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 sx={{
                                                     color: 'gray.600', // Default color
                                                     _selected: {
                                                         color: 'black', // Color when selected
                                                         bg: 'orange.100', // Background color when selected
                                                     },
                                                 }}
                                                 fontSize={!isMobile ? 15 : 13}>Single-Upload</Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                 // borderLeftWidth={'0.25px'}
                                                 // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Multi-Upload
                                                    {/*<Badge*/}
                                                    {/*    colorScheme="purple"*/}
                                                    {/*    variant="solid"*/}
                                                    {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                    {/*    fontSize="0.7em"*/}
                                                    {/*    borderRadius="5"*/}
                                                    {/*    px="2"*/}
                                                    {/*    py="1"*/}
                                                    {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                    {/*>*/}
                                                    {/*    NEW*/}
                                                    {/*</Badge>*/}
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                // borderLeftWidth={'0.25px'}
                                                // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Videos/MP3
                                                    {/* <Badge
                                                        colorScheme="purple"
                                                        variant="solid"
                                                        ml="3" // Adjust this margin to control spacing between text and badge
                                                        fontSize="0.7em"
                                                        borderRadius="5"
                                                        px="2"
                                                        py="1"
                                                        boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"
                                                    >
                                                        NEW
                                                    </Badge> */}
                                                    {/*<Badge*/}
                                                    {/*    colorScheme="purple"*/}
                                                    {/*    variant="solid"*/}
                                                    {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                    {/*    fontSize="0.7em"*/}
                                                    {/*    borderRadius="5"*/}
                                                    {/*    px="2"*/}
                                                    {/*    py="1"*/}
                                                    {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                    {/*>*/}
                                                    {/*    NEW*/}
                                                    {/*</Badge>*/}
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                 borderLeftWidth={'0.25px'}
                                                 borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column'}>
                                                    Audiobooks
                                                </Box>
                                            </Tab>
                                            {/*<Tab borderRadius={'0px'} sx={{*/}
                                            {/*    color: 'gray.600', // Default color*/}
                                            {/*    _selected: {*/}
                                            {/*        color: 'black', // Color when selected*/}
                                            {/*        bg: 'orange.100', // Background color when selected*/}
                                            {/*    },*/}
                                            {/*}} borderRightWidth={'0.25px'}*/}
                                            {/*     borderRightColor={'orange.100'}*/}
                                            {/*     borderBottomWidth={'0.25px'}*/}
                                            {/*     borderBottomColor={'orange.100'}*/}
                                            {/*     fontSize={!isMobile ? 15 : 13}>*/}
                                            {/*    <Box display="flex" alignItems="center">*/}
                                            {/*        Members*/}
                                            {/*    </Box>*/}
                                            {/*</Tab>*/}
                                            {/*<Tab borderRadius={'0px'} sx={{*/}
                                            {/*    color: 'gray.600', // Default color*/}
                                            {/*    _selected: {*/}
                                            {/*        color: 'black', // Color when selected*/}
                                            {/*        bg: 'orange.100', // Background color when selected*/}
                                            {/*    },*/}
                                            {/*}} borderRightWidth={'0.25px'}*/}
                                            {/*     borderRightColor={'orange.100'}*/}
                                            {/*     borderBottomWidth={'0.25px'}*/}
                                            {/*     borderBottomColor={'orange.100'}*/}
                                            {/*     fontSize={!isMobile ? 15 : 13}>*/}
                                            {/*    <Box display="flex" alignItems="center">*/}
                                            {/*        BigQuery*/}
                                            {/*    </Box>*/}
                                            {/*</Tab>*/}
                                        </TabList>

                                        <TabPanels px={2.5}>
                                            <TabPanel>
                                                {/* PDF Upload UI */}
                                                <MotionBox
                                                    {...getRootProps()}
                                                    border="2px"
                                                    borderColor="orange.400"
                                                    borderRadius="md"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="3"
                                                    mt={4}
                                                    pt={'1.05rem'}
                                                    cursor="pointer"
                                                    _hover={{ bg: 'gray.100' }}
                                                    animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    height="9rem"
                                                    onClick={() => {
                                                        if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                            toast({
                                                                title: t("You've reached your document limit in guest mode!"),
                                                                description: t("Please sign up to continue uploading documents."),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                            toast({
                                                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            dispatch(setIsPricingModalOpen(true));
                                                        }
                                                        else {
                                                            fileInput.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputProps()} ref={fileInput}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                        {t("Drag & Drop")}
                                                    </Text>
                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                </MotionBox>
                                            </TabPanel>

                                            {/*Multi-PDF Upload UI*/}
                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Chat with multiple files at the same time!
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to chat with multiple files at the same time!
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload multiple files",
                                                                    description: "Then you can chat with all of them at the same time!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                setWorkspaceLoading(true);
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>
                                            {/*Multi-PDF Upload UI*/}


                                            <TabPanel>
                                                {auth.isLoggedIn ?
                                                    <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={6} fontWeight="500" textAlign={'center'}>
                                                        Enter a YouTube link below or upload an mp4/mp3 file
                                                    </Text> :
                                                    <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={6} fontWeight="500" textAlign={'center'}>
                                                        Please sign up to use this feature!
                                                    </Text>
                                                }

                                                <Box mb={6} textAlign="center">
                                                    <Button
                                                        borderRadius={12}
                                                        px={6}
                                                        py={6}
                                                        fontSize={!isMobile ? 16 : 14}
                                                        colorScheme="orange"
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload mp4 or mp3 files",
                                                                    description: "Then you can chat with them just like with normal PDFs!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                fileInputVideo.current.click()
                                                            }
                                                        }}
                                                    >
                                                        Upload mp4 or mp3 File
                                                    </Button>
                                                    <input
                                                        type="file"
                                                        accept="video/*,audio/*"
                                                        onChange={handleMP4Upload}
                                                        ref={fileInputVideo}
                                                        style={{ display: "none" }}
                                                    />
                                                </Box>
                                                <URLInput
                                                    urlInput={urlInput}
                                                    setUrlInput={setUrlInput}
                                                    handleSubmit={handleSubmit}
                                                    currentPlaceholder={currentPlaceholder}
                                                    fade={fade}
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                {/*Audiobook Upload UI*/}
                                                <MotionBox
                                                    {...getRootPropsAudiobook()}
                                                    border="2px"
                                                    borderColor="orange.400"
                                                    borderRadius="md"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="3"
                                                    mt={4}
                                                    pt={'1.05rem'}
                                                    cursor="pointer"
                                                    _hover={{ bg: 'gray.100' }}
                                                    animate={isDragActiveAudiobook ? { scale: 1.05 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    height="9rem"
                                                    onClick={() => {
                                                        if (!auth.isLoggedIn) {
                                                            toast({
                                                                title: "Please sign up to create audiobooks",
                                                                description: "Listen 2x faster, and get a better understanding of your documents!",
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else {
                                                            fileInputAudiobook.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputPropsAudiobook({ accept: 'application/pdf' })} ref={fileInputAudiobook}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                        {t("Drag & Drop")}
                                                    </Text>
                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                </MotionBox>
                                            </TabPanel>


                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Chat with Multiple Files at the same time!
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to chat with multiple files at the same time.
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload multiple files",
                                                                    description: "Then you can chat with all of them at the same time!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                setWorkspaceLoading(true);
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>


                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Search and Chat with your entire database
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to search and chat with your entire database
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            setWorkspaceLoading(true);
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up",
                                                                    description: "Please sign up to search and chat with your entire database",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc2/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>


                                        </TabPanels>
                                    </Tabs>
                                </VStack>
                            </VStack>
                        : null}

                    {
                        areAllFilesEmpty(documents, videos, generations, audiobooks) ? (
                            <Box bg="white" minH="100vh" overflowX="hidden">
                                {/* Hero Section - White Background */}
                                <Box bg="white">
                                    <Container maxW="6xl">
                                        <VStack spacing={10} textAlign="center">
                                            <VStack spacing={6}>
                                                <Heading
                                                    fontSize={{ base: '5xl', md: '6xl', lg: '7xl' }}
                                                    fontWeight="700"
                                                    color="#1e293b"
                                                    mt={!isMobile ? 0 : -1}
                                                    lineHeight="1.05"
                                                    letterSpacing="-0.025em"
                                                >
                                                    Your AI Assistant
                                                    <br />
                                                    For Your Documents
                                                </Heading>

                                                <Text
                                                    fontSize={{ base: 'lg', md: '2xl' }}
                                                    color="#64748b"
                                                    maxW="4xl"
                                                    lineHeight="1.6"
                                                    px={4}
                                                    mt={4}
                                                >
                                                    <Text as="span" fontWeight="bold">5x</Text>&nbsp;your work with our custom AI. Extract key info, summarize, and generate
                                                    content from your documents. Transcribe video/audio files and get cited, high-quality
                                                    responses in seconds.
                                                </Text>
                                            </VStack>

                                            {/* File Type Icons - More realistic file icons */}
                                            <HStack spacing={3} py={0} ml={14}>
                                                <FileIcon label="PDF" bg="#dc2626" />
                                                <FileIcon label="DOC" bg="#2563eb" />
                                                <FileIcon label="MP4" bg="#475569" />
                                                <FileIcon label="PPT" bg="#ea580c" />
                                                <FileIcon label="MP3" bg="#0ea5e9" />
                                                <Text color="#64748b" fontSize="sm" fontWeight="medium">
                                                    + more
                                                </Text>
                                            </HStack>

                                            <VStack spacing={4} mt={0} mb={-2}>
                                                <Button
                                                    borderRadius={16}
                                                    px={isMobile ? 6 : 7}
                                                    py={isMobile ? 6 : 7}
                                                    fontSize={isMobile ? 18 : 22}
                                                    colorScheme={'orange'}
                                                    bgGradient="linear(to-r, orange.400, orange.500)"
                                                    _hover={{
                                                        bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                        boxShadow: 'lg' // Adds a slight shadow on hover
                                                    }}
                                                    onClick={() => {
                                                        if (auth.isLoggedIn) {
                                                            fileInput.current.click();
                                                        } else {
                                                            onOpenSignUpScreen1();
                                                        }
                                                    }}>
                                                    {auth.isLoggedIn ? t('Upload') : t('Get started')}
                                                </Button>
                                                {/*<Text color="#64748b" fontSize="sm" fontWeight={500}>No credit card required.</Text>*/}
                                            </VStack>

                                            {isUploadLoading ?
                                                <LoadingBar progress={uploadProgress} isMarginBottom={true}/> :
                                                <VStack width={!isMobile ? "140%" : "115%"} height={'21rem'} mb={'4rem'} mt='1rem' spacing={5}>
                                                    <VStack
                                                        width={{
                                                            base: '88%',
                                                            sm: '70%',
                                                            md: '60%',
                                                            lg: '55%',
                                                            xl: '50%',
                                                        }}
                                                        bg={'white'}
                                                        height={'21rem'}
                                                        borderRadius={'15px'}
                                                        spacing={4}
                                                        borderColor={'lightgray'}
                                                        borderWidth={0.25}
                                                        shadow={`1.5px 1.8px 0px lightgray`}
                                                        position="relative"
                                                    >
                                                        <Tabs
                                                            variant="soft-rounded"
                                                            colorScheme="orange"
                                                            onChange={handleTabChange}
                                                            index={tabIndex}
                                                            width="100%"
                                                            position="absolute"
                                                            top="0rem"
                                                            left="0rem"
                                                            zIndex={1}
                                                        >
                                                            <TabList>
                                                                <Tab borderTopLeftRadius={'15px'}
                                                                     borderTopRightRadius={'0px'}
                                                                     borderBottomRadius={'0px'}
                                                                     borderBottomWidth={'0.25px'}
                                                                     borderBottomColor={'orange.100'}
                                                                     sx={{
                                                                         color: 'gray.600', // Default color
                                                                         _selected: {
                                                                             color: 'black', // Color when selected
                                                                             bg: 'orange.100', // Background color when selected
                                                                         },
                                                                     }}
                                                                     fontSize={!isMobile ? 15 : 13}>Single-Upload</Tab>
                                                                <Tab borderRadius={'0px'} sx={{
                                                                    color: 'gray.600', // Default color
                                                                    _selected: {
                                                                        color: 'black', // Color when selected
                                                                        bg: 'orange.100', // Background color when selected
                                                                    },
                                                                }} borderRightWidth={'0.25px'}
                                                                     borderRightColor={'orange.100'}
                                                                    // borderLeftWidth={'0.25px'}
                                                                    // borderLeftColor={'orange.100'}
                                                                     borderBottomWidth={'0.25px'}
                                                                     borderBottomColor={'orange.100'}
                                                                     fontSize={!isMobile ? 15 : 13}>
                                                                    <Box display="flex" alignItems="center">
                                                                        Multi-Upload
                                                                        {/*<Badge*/}
                                                                        {/*    colorScheme="purple"*/}
                                                                        {/*    variant="solid"*/}
                                                                        {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                                        {/*    fontSize="0.7em"*/}
                                                                        {/*    borderRadius="5"*/}
                                                                        {/*    px="2"*/}
                                                                        {/*    py="1"*/}
                                                                        {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                                        {/*>*/}
                                                                        {/*    NEW*/}
                                                                        {/*</Badge>*/}
                                                                    </Box>
                                                                </Tab>
                                                                <Tab borderRadius={'0px'} sx={{
                                                                    color: 'gray.600', // Default color
                                                                    _selected: {
                                                                        color: 'black', // Color when selected
                                                                        bg: 'orange.100', // Background color when selected
                                                                    },
                                                                }} borderRightWidth={'0.25px'}
                                                                     borderRightColor={'orange.100'}
                                                                    // borderLeftWidth={'0.25px'}
                                                                    // borderLeftColor={'orange.100'}
                                                                     borderBottomWidth={'0.25px'}
                                                                     borderBottomColor={'orange.100'}
                                                                     fontSize={!isMobile ? 15 : 13}>
                                                                    <Box display="flex" alignItems="center">
                                                                        Videos/MP3
                                                                        {/* <Badge
                                                        colorScheme="purple"
                                                        variant="solid"
                                                        ml="3" // Adjust this margin to control spacing between text and badge
                                                        fontSize="0.7em"
                                                        borderRadius="5"
                                                        px="2"
                                                        py="1"
                                                        boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"
                                                    >
                                                        NEW
                                                    </Badge> */}
                                                                        {/*<Badge*/}
                                                                        {/*    colorScheme="purple"*/}
                                                                        {/*    variant="solid"*/}
                                                                        {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                                        {/*    fontSize="0.7em"*/}
                                                                        {/*    borderRadius="5"*/}
                                                                        {/*    px="2"*/}
                                                                        {/*    py="1"*/}
                                                                        {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                                        {/*>*/}
                                                                        {/*    NEW*/}
                                                                        {/*</Badge>*/}
                                                                    </Box>
                                                                </Tab>
                                                                <Tab borderRadius={'0px'} sx={{
                                                                    color: 'gray.600', // Default color
                                                                    _selected: {
                                                                        color: 'black', // Color when selected
                                                                        bg: 'orange.100', // Background color when selected
                                                                    },
                                                                }} borderRightWidth={'0.25px'}
                                                                     borderRightColor={'orange.100'}
                                                                     borderLeftWidth={'0.25px'}
                                                                     borderLeftColor={'orange.100'}
                                                                     borderBottomWidth={'0.25px'}
                                                                     borderBottomColor={'orange.100'}
                                                                     fontSize={!isMobile ? 15 : 13}>
                                                                    <Box display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column'}>
                                                                        Audiobooks
                                                                    </Box>
                                                                </Tab>
                                                            </TabList>

                                                            <TabPanels px={2.5}>
                                                                <TabPanel>
                                                                    {/* PDF Upload UI */}
                                                                    <MotionBox
                                                                        {...getRootProps()}
                                                                        border="2px"
                                                                        borderColor="orange.400"
                                                                        borderRadius="md"
                                                                        borderStyle="dashed"
                                                                        textAlign="center"
                                                                        p="3"
                                                                        mt={4}
                                                                        pt={'1.05rem'}
                                                                        cursor="pointer"
                                                                        _hover={{ bg: 'gray.100' }}
                                                                        animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                                                        transition={{ duration: 0.2 }}
                                                                        width="100%"
                                                                        height="9rem"
                                                                        onClick={() => {
                                                                            if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                                                toast({
                                                                                    title: t("You've reached your document limit in guest mode!"),
                                                                                    description: t("Please sign up to continue uploading documents."),
                                                                                    status: "info",
                                                                                    duration: 9000,
                                                                                    isClosable: true,
                                                                                    position: "top",
                                                                                });
                                                                                onOpenSignUpScreen1();
                                                                            }
                                                                            else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                                                toast({
                                                                                    title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                                                                    status: "info",
                                                                                    duration: 9000,
                                                                                    isClosable: true,
                                                                                    position: "top",
                                                                                });
                                                                                dispatch(setIsPricingModalOpen(true));
                                                                            }
                                                                            else {
                                                                                fileInput.current.click();
                                                                            }
                                                                        }}
                                                                    >
                                                                        <input {...getInputProps()} ref={fileInput}/>
                                                                        <Box as="span" color="gray.400" fontSize="3xl">
                                                                            ⇧
                                                                        </Box>
                                                                        <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                                            {t("Drag & Drop")}
                                                                        </Text>
                                                                        <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                                    </MotionBox>
                                                                    <VStack spacing={4} width={'100%'} bg={'white'} mt={'2.75rem'}>
                                                                        {/*<Text fontSize={18} fontWeight={'bold'}>{t("No PDFs yet")}</Text>*/}
                                                                        <Text color={"black"} textAlign={'center'} fontSize={!isMobile ? 17 : 15} fontWeight={"500"}>{t("Upload and AI chat with any PDF.")}</Text>
                                                                        {/*<Text color={"black"} textAlign={'center'} fontSize={17} fontWeight={"500"}>{t("Summarize, extract key insights, ask any question, and more.")}</Text>*/}
                                                                    </VStack>
                                                                </TabPanel>

                                                                {/*Multi-PDF Upload UI*/}
                                                                <TabPanel>
                                                                    <VStack>
                                                                        {auth.isLoggedIn ?
                                                                            <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                                                Chat with Multiple Files at the same time!
                                                                            </Text> :
                                                                            <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={8} mb={12} fontWeight="500" textAlign={'center'}>
                                                                                Sign up to AI chat with multiple files at the same time.
                                                                            </Text>
                                                                        }

                                                                        <Button
                                                                            borderRadius={12}
                                                                            isLoading={workspaceLoading}
                                                                            px={6}
                                                                            py={6}
                                                                            fontSize={!isMobile ? 18 : 16}
                                                                            colorScheme={'orange'}
                                                                            bgGradient="linear(to-r, orange.400, orange.500)"
                                                                            _hover={{
                                                                                bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                                                boxShadow: 'lg' // Adds a slight shadow on hover
                                                                            }}
                                                                            onClick={() => {
                                                                                if (!auth.isLoggedIn) {
                                                                                    toast({
                                                                                        title: "Please sign up to upload multiple files",
                                                                                        description: "Then you can chat with all of them at the same time!",
                                                                                        status: "info",
                                                                                        duration: 9000,
                                                                                        isClosable: true,
                                                                                        position: "top",
                                                                                    });
                                                                                    onOpenSignUpScreen1();
                                                                                } else {
                                                                                    setWorkspaceLoading(true);
                                                                                    const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                                    initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                                        setWorkspaceLoading(false);
                                                                                        navigate(`/multidoc/${r.id}`)
                                                                                        window.location.reload();
                                                                                        console.log("initialize multidoc here", r)
                                                                                    });
                                                                                }

                                                                            }}>
                                                                            Create new Workspace
                                                                        </Button>
                                                                    </VStack>
                                                                </TabPanel>
                                                                {/*Multi-PDF Upload UI*/}


                                                                <TabPanel>
                                                                    {auth.isLoggedIn ?
                                                                        <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={6} fontWeight="500" textAlign={'center'}>
                                                                            Enter a YouTube link below or upload an mp4 file
                                                                        </Text> :
                                                                        <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={8} fontWeight="500" textAlign={'center'}>
                                                                            Sign up to AI chat with any video.
                                                                        </Text>
                                                                    }

                                                                    <Box mb={auth.isLoggedIn ? 6 : 10} textAlign="center">
                                                                        <Button
                                                                            borderRadius={12}
                                                                            px={6}
                                                                            py={6}
                                                                            fontSize={!isMobile ? 17 : 15}
                                                                            colorScheme="orange"
                                                                            onClick={() => {
                                                                                if (!auth.isLoggedIn) {
                                                                                    toast({
                                                                                        title: "Please sign up to upload mp4 videos",
                                                                                        description: "Then you can chat with them just like with normal PDFs!",
                                                                                        status: "info",
                                                                                        duration: 9000,
                                                                                        isClosable: true,
                                                                                        position: "top",
                                                                                    });
                                                                                    onOpenSignUpScreen1();
                                                                                } else {
                                                                                    fileInputVideo.current.click()
                                                                                }
                                                                            }}
                                                                        >
                                                                            Upload mp4 or mp3 File
                                                                        </Button>
                                                                        <input
                                                                            type="file"
                                                                            accept="video/mp4"
                                                                            onChange={handleMP4Upload}
                                                                            ref={fileInputVideo}
                                                                            style={{ display: "none" }}
                                                                        />
                                                                    </Box>
                                                                    <URLInput
                                                                        urlInput={urlInput}
                                                                        setUrlInput={setUrlInput}
                                                                        handleSubmit={handleSubmit}
                                                                        currentPlaceholder={currentPlaceholder}
                                                                        fade={fade}
                                                                    />
                                                                </TabPanel>

                                                                <TabPanel>
                                                                    {/*Audiobook Upload UI*/}
                                                                    <MotionBox
                                                                        {...getRootPropsAudiobook()}
                                                                        border="2px"
                                                                        borderColor="orange.400"
                                                                        borderRadius="md"
                                                                        borderStyle="dashed"
                                                                        textAlign="center"
                                                                        p="3"
                                                                        mt={4}
                                                                        pt={'1.05rem'}
                                                                        cursor="pointer"
                                                                        _hover={{ bg: 'gray.100' }}
                                                                        animate={isDragActiveAudiobook ? { scale: 1.05 } : { scale: 1 }}
                                                                        transition={{ duration: 0.2 }}
                                                                        width="100%"
                                                                        height="9rem"
                                                                        onClick={() => {
                                                                            if (!auth.isLoggedIn) {
                                                                                toast({
                                                                                    title: "Please sign up to create audiobooks",
                                                                                    description: "Listen 2x faster, and get a better understanding of your documents!",
                                                                                    status: "info",
                                                                                    duration: 9000,
                                                                                    isClosable: true,
                                                                                    position: "top",
                                                                                });
                                                                                onOpenSignUpScreen1();
                                                                            }
                                                                            else {
                                                                                fileInputAudiobook.current.click();
                                                                            }
                                                                        }}
                                                                    >
                                                                        <input {...getInputPropsAudiobook({ accept: 'application/pdf' })} ref={fileInputAudiobook}/>
                                                                        <Box as="span" color="gray.400" fontSize="3xl">
                                                                            ⇧
                                                                        </Box>
                                                                        <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                                            {t("Drag & Drop")}
                                                                        </Text>
                                                                        <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                                    </MotionBox>
                                                                    <VStack spacing={4} width={'100%'} bg={'white'} mt={!isMobile ? '2.75rem' : '1.9rem'}>
                                                                        {/*<Text fontSize={18} fontWeight={'bold'}>{t("No PDFs yet")}</Text>*/}
                                                                        <Text color={"black"} textAlign={'center'} fontSize={!isMobile ? 17 : 15} fontWeight={"500"}>{t("Upload a PDF and get an audiobook that reads it to you!")}</Text>
                                                                        {/*<Text color={"gray.700"}>{t("Extract key information, summarize, generate notes or practice questions, and much more.")}</Text>*/}
                                                                    </VStack>
                                                                </TabPanel>

                                                            </TabPanels>
                                                        </Tabs>
                                                    </VStack>
                                                </VStack>
                                            }
                                        </VStack>
                                    </Container>
                                </Box>

                                {/* Company Logos */}
                                <LogoCarousel3/>

                                {/* Gradient Background Starts - Light blue to darker blue */}
                                <Box
                                    bgGradient="linear(to-b, white 0%, #f8fafc 20%, #f1f8ff 60%, #f0f8fe 100%)"
                                    pb={16}
                                    mt={0}
                                >
                                    {/* Three Feature Cards */}
                                    <Container maxW="7xl" pt={16}>
                                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
                                            {/* Find Information */}
                                            <Box
                                                p={10}
                                                bg="white"
                                                borderRadius="2xl"
                                                boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                border="1px"
                                                borderColor="rgba(255, 255, 255, 0.2)"
                                                position="relative"
                                                _hover={{
                                                    transform: "translateY(-8px)",
                                                    boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                }}
                                                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                _before={{
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: "4px",
                                                    bg: "linear-gradient(90deg, #2563eb, #3b82f6, #60a5fa)",
                                                    borderTopRadius: "2xl"
                                                }}
                                            >
                                                <VStack spacing={6} align="start">
                                                    <VStack spacing={4} align="start">
                                                        <Box
                                                            p={3}
                                                            bg="linear-gradient(135deg, #eff6ff, #dbeafe)"
                                                            borderRadius="xl"
                                                            border="1px"
                                                            borderColor="#bfdbfe"
                                                        >
                                                            <Icon as={FiSearch} color="#2563eb" w={6} h={6} />
                                                        </Box>
                                                        <Heading size="lg" color="#1e293b" fontWeight="bold">Extract Key Information</Heading>
                                                    </VStack>
                                                    <VStack spacing={4} align="start">
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Efficiently search through all of your documents and files.
                                                        </Text>
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Extract key information & insights and get your questions answered.
                                                        </Text>
                                                    </VStack>
                                                </VStack>
                                            </Box>

                                            {/* Summarize Content */}
                                            <Box
                                                p={10}
                                                bg="white"
                                                borderRadius="2xl"
                                                boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                border="1px"
                                                borderColor="rgba(255, 255, 255, 0.2)"
                                                position="relative"
                                                _hover={{
                                                    transform: "translateY(-8px)",
                                                    boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                }}
                                                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                _before={{
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: "4px",
                                                    bg: "linear-gradient(90deg, #10b981, #34d399, #6ee7b7)",
                                                    borderTopRadius: "2xl"
                                                }}
                                            >
                                                <VStack spacing={6} align="start">
                                                    <VStack spacing={4} align="start">
                                                        <Box
                                                            p={3}
                                                            bg="linear-gradient(135deg, #ecfdf5, #d1fae5)"
                                                            borderRadius="xl"
                                                            border="1px"
                                                            borderColor="#a7f3d0"
                                                        >
                                                            <Icon as={FiFileText} color="#10b981" w={6} h={6} />
                                                        </Box>
                                                        <Heading size="lg" color="#1e293b" fontWeight="bold">
                                                            Summarize Any Content
                                                        </Heading>
                                                    </VStack>
                                                    <VStack spacing={4} align="start">
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Accurately summarize research papers, reports, books, case studies—you name it.
                                                        </Text>
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Generate notes in seconds from presentations, meetings, lectures, readings, & more.
                                                        </Text>
                                                    </VStack>
                                                </VStack>
                                            </Box>

                                            {/* Generate Deliverables */}
                                            <Box
                                                p={10}
                                                bg="white"
                                                borderRadius="2xl"
                                                boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                border="1px"
                                                borderColor="rgba(255, 255, 255, 0.2)"
                                                position="relative"
                                                _hover={{
                                                    transform: "translateY(-8px)",
                                                    boxShadow: "0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.9)"
                                                }}
                                                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                _before={{
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: "4px",
                                                    bg: "linear-gradient(90deg, #8b5cf6, #a78bfa, #c4b5fd)",
                                                    borderTopRadius: "2xl"
                                                }}
                                            >
                                                <VStack spacing={6} align="start">
                                                    <VStack spacing={4} align="start">
                                                        <Box
                                                            p={3}
                                                            bg="linear-gradient(135deg, #f5f3ff, #ede9fe)"
                                                            borderRadius="xl"
                                                            border="1px"
                                                            borderColor="#c4b5fd"
                                                        >
                                                            <Icon as={FiEdit3} color="#8b5cf6" w={6} h={6} />
                                                        </Box>
                                                        <Heading size="lg" color="#1e293b" fontWeight="bold">
                                                            Create
                                                            <br />
                                                            Deliverables
                                                        </Heading>
                                                    </VStack>
                                                    <VStack spacing={4} align="start">
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Generate proposals, practice quizzes, cover letters, memos, reports, & more.
                                                        </Text>
                                                        <Text color="#64748b" lineHeight="1.7" fontSize="md">
                                                            Or have our AI improve/edit your content.
                                                        </Text>
                                                    </VStack>
                                                </VStack>
                                            </Box>
                                        </SimpleGrid>
                                    </Container>

                                    {/* Interactive Demo Section */}
                                    <Box justify={'center'} align={'center'} mt={'6.5rem'}
                                         display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                        <Box
                                            width={['100%','89%', '81%', '73%', '64%']}
                                            borderRadius={!isMobile ? 20 : 0}
                                            overflow="hidden"
                                            position="relative"
                                            transform="translateY(0)"
                                            transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                            _hover={{
                                                transform: "translateY(-8px)",
                                                boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                                            }}
                                            boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                                            _before={{
                                                content: '""',
                                                position: 'absolute',
                                                top: '-2px',
                                                left: '-2px',
                                                right: '-2px',
                                                bottom: '-2px',
                                                background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                                borderRadius: !isMobile ? 22 : 2,
                                                zIndex: -1,
                                                opacity: 0.8
                                            }}
                                            _after={{
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                                borderRadius: !isMobile ? 20 : 0,
                                                pointerEvents: 'none',
                                                zIndex: 1
                                            }}>

                                            <LazyLoad height={'auto'} width={'100%'} offset={100}>
                                                <ReactPlayer
                                                    url={process.env.PUBLIC_URL + '/new_landing_page_video.m4v'}
                                                    playing={true} // auto-play on load
                                                    loop={true} // auto-looping
                                                    playbackRate={1} // 1x speed
                                                    muted={true}
                                                    controls={true} // show video controls
                                                    width={'100%'} // full width
                                                    height="auto"
                                                    style={{
                                                        position: 'relative',
                                                        zIndex: 2
                                                    }}>
                                                </ReactPlayer>
                                            </LazyLoad>
                                        </Box>
                                    </Box>

                                    {/* Features Section - Continued gradient */}
                                    <Container maxW="7xl" py={8} mt={14} ref={featuresRef}>
                                        <Heading size="2xl" textAlign="center" color="#1e293b" mb={12} fontWeight="bold">
                                            Features
                                        </Heading>

                                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
                                            {/* Generate Summaries */}
                                            <Box p={14} pt={12} bg="white" borderRadius="xl" border="1px" borderColor="#e2e8f0" boxShadow="sm">
                                                <VStack spacing={6} align="start">
                                                    <Heading size="lg" color="#1e293b" fontWeight="bold">Instant, Detailed Summaries</Heading>
                                                    <Text color="#64748b" lineHeight="1.6" fontSize="lg">
                                                        Get summaries of dense documents that give you the key points and insights you need, without the fluff.
                                                        Supports scanned documents with OCR technology.
                                                    </Text>
                                                    <Box w="full" borderRadius="lg" border="1px" borderColor="#e2e8f0" overflow="hidden">
                                                        <Image
                                                            src={process.env.PUBLIC_URL + "/HB_newlandingpage1.jpg"} // Replace with your actual image filename
                                                            alt="Generate Summaries Feature"
                                                            width="100%" // Control width - can be "100%", "400px", etc.
                                                            height="auto" // Control height - can be "auto", "200px", etc.
                                                            objectFit="cover" // How image fits: "cover", "contain", "fill"
                                                            borderRadius="lg"
                                                        />
                                                    </Box>
                                                </VStack>
                                            </Box>

                                            {/* Get Highlighted Citations */}
                                            <Box p={14} pt={12} bg="white" borderRadius="xl" border="1px" borderColor="#e2e8f0" boxShadow="sm">
                                                <VStack spacing={6} align="start">
                                                    <Heading size="lg" color="#1e293b" fontWeight="bold">Clickable In-text Citations</Heading>
                                                    <Text color="#64748b" lineHeight="1.6" fontSize="lg">
                                                        For every response, get clickable in-text citations that link to the exact page with the information.
                                                    </Text>
                                                    <Box w="full" borderRadius="lg" border="1px" borderColor="#e2e8f0" overflow="hidden">
                                                        <Image
                                                            src={process.env.PUBLIC_URL + "/HB_newlandingpage2.jpg"} // Replace with your actual image filename
                                                            alt="Generate Summaries Feature"
                                                            width="100%" // Control width - can be "100%", "400px", etc.
                                                            height="auto" // Control height - can be "auto", "200px", etc.
                                                            objectFit="cover" // How image fits: "cover", "contain", "fill"
                                                            borderRadius="lg"
                                                        />
                                                    </Box>
                                                </VStack>
                                            </Box>

                                            {/* Chat With 100+ Files At Once */}
                                            <Box p={14} pt={12} bg="white" borderRadius="xl" border="1px" borderColor="#e2e8f0" boxShadow="sm">
                                                <VStack spacing={6} align="start">
                                                    <Heading size="lg" color="#1e293b" fontWeight="bold">Chat With 50+ Files At Once</Heading>
                                                    <Text color="#64748b" lineHeight="1.6" fontSize="lg">
                                                        Upload all your files at once for comprehensive analysis. Locate specific information quickly
                                                        among all your files.
                                                    </Text>
                                                    <Box w="full" borderRadius="lg" border="1px" borderColor="#e2e8f0" overflow="hidden">
                                                        <Image
                                                            src={process.env.PUBLIC_URL + "/5_screenshot.jpg"} // Replace with your actual image filename
                                                            alt="Generate Summaries Feature"
                                                            width="100%" // Control width - can be "100%", "400px", etc.
                                                            height="auto" // Control height - can be "auto", "200px", etc.
                                                            objectFit="cover" // How image fits: "cover", "contain", "fill"
                                                            borderRadius="lg"
                                                        />
                                                    </Box>
                                                </VStack>
                                            </Box>

                                            {/* Transcribe Audio & Video Files */}
                                            <Box p={14} pt={12} bg="white" borderRadius="xl" border="1px" borderColor="#e2e8f0" boxShadow="sm">
                                                <VStack spacing={6} align="start">
                                                    <Heading size="lg" color="#1e293b" fontWeight="bold">Transcribe Video/Audio Files</Heading>
                                                    <Text color="#64748b" lineHeight="1.6" fontSize="lg">
                                                        Chat and get answers from any video, audio file, or YouTube video.
                                                        Get accurate transcriptions with timestamps and speaker labels.
                                                    </Text>
                                                    <Box w="full" borderRadius="lg" border="1px" borderColor="#e2e8f0" overflow="hidden">
                                                        <VStack spacing={0} w="full">
                                                            <Image
                                                                src={process.env.PUBLIC_URL + "/HB_newlandingpage4.jpg"} // Replace with your first image filename
                                                                alt="Generate Summaries Feature - Top"
                                                                width="100%" // Control width - can be "100%", "400px", etc.
                                                                height="auto" // Control height - can be "auto", "200px", etc.
                                                                objectFit="cover" // How image fits: "cover", "contain", "fill"
                                                            />
                                                            <Image
                                                                src={process.env.PUBLIC_URL + "/HB_newlandingpage5.jpg"} // Replace with your second image filename
                                                                alt="Generate Summaries Feature - Bottom"
                                                                width="100%" // Control width - can be "100%", "400px", etc.
                                                                height="auto" // Control height - can be "auto", "200px", etc.
                                                                objectFit="cover" // How image fits: "cover", "contain", "fill"
                                                            />
                                                        </VStack>
                                                    </Box>
                                                </VStack>
                                            </Box>
                                        </SimpleGrid>
                                    </Container>
                                </Box>

                                {/* How It Works - Back to White Background */}
                                <Box bg="white" py={16}>
                                    <Container maxW="7xl">
                                        <Heading size="2xl" textAlign="center" color="#1e293b" mb={12} fontWeight="bold">
                                            How It Works
                                        </Heading>

                                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={{ base: 4, md: 8 }}>
                                            {/* Step 1: Upload */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                                gridColumn={{ base: "auto", md: "span 2", lg: "auto" }}
                                            >
                                                <Box
                                                    w="full"
                                                    borderRadius="lg"
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    overflow="hidden"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <Image
                                                        src={process.env.PUBLIC_URL + "/HB_newlandingpage7.jpg"}
                                                        alt="Generate Summaries Feature"
                                                        width="100%"
                                                        height="100%"
                                                        objectFit="cover"
                                                        borderRadius="lg"
                                                    />
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">1) Upload</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Upload any file you have.
                                                    </Text>
                                                </VStack>
                                            </Box>

                                            {/* Step 2: Ask Questions */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                            >
                                                <Box
                                                    w="full"
                                                    bg="white"
                                                    borderRadius="lg"
                                                    p={{ base: 3, md: 4 }}
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <VStack spacing={3} w="full">
                                                        <Box w="full" p={3} bg="#eff6ff" borderRadius="lg" border="1px" borderColor="#bfdbfe">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#1e293b" textAlign="left">
                                                                What is the main argument of this document? Respond in Spanish.
                                                            </Text>
                                                        </Box>
                                                        <Box w="full" p={3} bg="white" borderRadius="lg" border="1px" borderColor="#e2e8f0">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#64748b" textAlign="left">
                                                                Create 30 difficult multiple-choice questions based on this lecture.
                                                            </Text>
                                                        </Box>
                                                        <Box w="full" p={3} bg="white" borderRadius="lg" border="1px" borderColor="#e2e8f0">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#64748b" textAlign="left">
                                                                Which quotes are most relevant in supporting my thesis statement?
                                                            </Text>
                                                        </Box>
                                                    </VStack>
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">2) Ask Any Questions</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Give Honeybear.ai a question or prompt.
                                                    </Text>
                                                </VStack>
                                            </Box>

                                            {/* Step 3: Get Answers */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                            >
                                                <Box
                                                    w="full"
                                                    bg="white"
                                                    borderRadius="lg"
                                                    p={{ base: 3, md: 4 }}
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <VStack spacing={3} align="start" w="full">
                                                        <Text fontSize={{ base: "sm", md: "sm" }} color="orange.700" fontWeight="bold">
                                                            What methodology does the author use?
                                                        </Text>
                                                        <Text
                                                            fontSize={{ base: "xs", md: "xs" }}
                                                            color="#1e293b"
                                                            lineHeight="1.5"
                                                            textAlign="left"
                                                        >
                                                            The authors employ a comprehensive econometric methodology centered on a three-equation system that
                                                            uses 2SLS and 3SLS estimation techniques to
                                                            address endogeneity problems in resource curse research [1]. Their key methodological innovation involves
                                                            distinguishing between resource "abundance" and resource "dependence" [2].
                                                        </Text>
                                                    </VStack>
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">3) Get Answers</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Get highest-quality responses that are accurate, reliable, and highly detailed.
                                                    </Text>
                                                </VStack>
                                            </Box>
                                        </SimpleGrid>
                                    </Container>
                                </Box>

                                {/* Testimonials - Light Blue Background Again */}
                                <Box bg="white" py={16} ref={testimonialsRef}>
                                    <Container maxW="6xl">
                                        <Heading size="2xl" textAlign="center" color="#1e293b" mb={12} fontWeight="bold" px={!isMobile ? 0 : 4}>
                                            Join 1 million+ students,
                                            <br />
                                            researchers & professionals
                                        </Heading>

                                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
                                            {/* Testimonial 1 */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={4}>
                                                    <Avatar size="md" name="Jennifer Ku" bg="#3b82f6" src={process.env.PUBLIC_URL + "/Big_Testimonial.jpg"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Jennifer Ku</Text>
                                                        <Text color="#64748b" fontSize="xs">@jennkuu</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5">
                                                    As a doctoral student, Honeybear.ai has been an invaluable tool in my research journey. I highly recommend it to fellow researchers & scholars looking to optimize their research process!
                                                </Text>
                                            </Box>

                                            {/* Testimonial 2 */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={4}>
                                                    <Avatar size="md" name="Cecile Schreidah" bg="#10b981" src={process.env.PUBLIC_URL + "/Cecile_Headshot.jpg"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Cecile Schreidah</Text>
                                                        <Text color="#64748b" fontSize="xs">@cecileschreidah</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5">
                                                    As a STEM student consistently immersed in reading research papers and conducting literature reviews, Honeybear.ai has increased the efficiency of my studying & research!
                                                </Text>
                                            </Box>

                                            {/* Testimonial 3 */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={4}>
                                                    <Avatar size="md" name="Logan Clouser" bg="#8b5cf6" src={process.env.PUBLIC_URL + "/Logan_Headshot.jpg"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Logan Clouser</Text>
                                                        <Text color="#64748b" fontSize="xs">@loganclouser</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5">
                                                    Honeybear.ai has allowed me to work more efficiently and gain a broader and deeper understanding of topics throughout my college curriculum.
                                                </Text>
                                            </Box>

                                            {/* Additional testimonials row */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={4}>
                                                    <Avatar size="md" name="Yash Mehta" bg="#f59e0b" src={process.env.PUBLIC_URL + "/Yash_Headshot.jpeg"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Yash Mehta</Text>
                                                        <Text color="#64748b" fontSize="xs">@ymehta</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5">
                                                    After using Honeybear.ai for quite a bit, I've noticed its responses
                                                    are better quality than ChatGPT's. Very impressive. For my analysis-intensive job,
                                                    Honeybear has proven to be a dependable and reliable tool unlike some other
                                                    websites I have tried that only provide value for certain documents.
                                                </Text>
                                            </Box>

                                            {/* Video testimonial */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0" height={'350px'}>
                                                <Box
                                                    w="full"
                                                    h="100%"
                                                    bg="#1f2937"
                                                    borderRadius="lg"
                                                    mb={4}
                                                    position="relative"
                                                    overflow="hidden"
                                                    cursor="pointer"
                                                    transition="transform 0.2s"
                                                    _hover={{ transform: "scale(1.02)" }}
                                                    onClick={() => window.open('https://www.instagram.com/p/C5V-JoxrYMB/', '_blank')} // Replace YOUR_POST_ID with actual Instagram post ID
                                                >
                                                    {/* Instagram video embed or thumbnail */}
                                                    <video
                                                        width="100%"
                                                        height="100%"
                                                        style={{ objectFit: 'cover' }}
                                                        muted
                                                        loop
                                                        playsInline
                                                        poster={process.env.PUBLIC_URL + "/ellie_thumbnail.jpg"} // Optional: thumbnail image
                                                    >
                                                        <source src={process.env.PUBLIC_URL + "/insta_video.mp4"} type="video/mp4" />
                                                        {/* Fallback for when video doesn't load */}
                                                        <Box w="full" h="full" bg="#1f2937" display="flex" alignItems="center" justifyContent="center">
                                                            <Icon as={FiPlay} color="white" w={8} h={8} />
                                                        </Box>
                                                    </video>

                                                    {/* Play button overlay */}
                                                    <Box
                                                        position="absolute"
                                                        top="50%"
                                                        left="50%"
                                                        transform="translate(-50%, -50%)"
                                                        bg="rgba(0,0,0,0.7)"
                                                        borderRadius="full"
                                                        p={3}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Icon as={FiPlay} color="white" w={6} h={6} />
                                                    </Box>

                                                    {/* Instagram icon indicator */}
                                                    <Box position="absolute" top={2} right={2}>
                                                        <Box
                                                            bg="rgba(0,0,0,0.8)"
                                                            p={1}
                                                            borderRadius="md"
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                                                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                                            </svg>
                                                        </Box>
                                                    </Box>

                                                    {/* Caption overlay */}
                                                    <Box position="absolute" bottom={2} left={2} right={2}>
                                                        <Text color="white" fontSize="xs" bg="rgba(0,0,0,0.5)" px={2} py={1} borderRadius="md">
                                                            Send this to a friend ✌️

                                                            Special thank you to @justin.rhee for introducing me to this tool ✨
                                                        </Text>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            {/* More testimonials */}
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={4}>
                                                    <Avatar size="md" name="Teo Janiga" bg="#ef4444" src={process.env.PUBLIC_URL + "/Teo_Headshot.jpg"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Teo Janiga</Text>
                                                        <Text color="#64748b" fontSize="xs">@teodor_janiga</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5">
                                                    Honeybear.ai is so much better than other AI websites. The answers it gives are much more accurate & detailed, unlike other sites that often glaze over the document. Truly a lifesaver!
                                                </Text>
                                            </Box>
                                        </SimpleGrid>

                                        <HStack spacing={8} mt={8} justify="center" width={'100%'}>
                                            <Box p={6} bg="white" borderRadius="2xl"
                                                 boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"
                                                 border="1px"
                                                 borderColor="#e2e8f0">
                                                <HStack spacing={3} mb={2}>
                                                    <Avatar size="md" name="Obi Okasi" bg="#06b6d4" src={process.env.PUBLIC_URL + "/Obi_Headshot.JPG"} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="bold" color="#1e293b" fontSize="sm">Obi Okasi</Text>
                                                        <Text color="#64748b" fontSize="xs">@obiokasi</Text>
                                                    </VStack>
                                                </HStack>
                                                <Text color="#1e293b" fontSize="sm" lineHeight="1.5" mt={4}>
                                                    I've been using Honeybear.ai every day and it's fantastic! I especially like how you can chat with so many files at the same time.
                                                </Text>
                                            </Box>

                                            {/*<Box p={6} bg="white" borderRadius="2xl"*/}
                                            {/*     boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)"*/}
                                            {/*     border="1px"*/}
                                            {/*     borderColor="#e2e8f0">*/}
                                            {/*    <HStack spacing={3} mb={2}>*/}
                                            {/*        <Avatar size="sm" name="Cyrus Mbabazi" bg="#84cc16" />*/}
                                            {/*        <VStack align="start" spacing={0}>*/}
                                            {/*            <Text fontWeight="bold" color="#1e293b" fontSize="sm">Brandon Yang</Text>*/}
                                            {/*            <Text color="#64748b" fontSize="xs">@byyang12</Text>*/}
                                            {/*        </VStack>*/}
                                            {/*    </HStack>*/}
                                            {/*    <Text color="#1e293b" fontSize="sm" lineHeight="1.5" mt={4}>*/}
                                            {/*        Honeybear has been extremely useful in my day-to-day work, and it has proven to be a valuable tool for my research and studies.*/}
                                            {/*    </Text>*/}
                                            {/*</Box>*/}
                                        </HStack>
                                    </Container>
                                </Box>

                                {/* Quote Section - Light Blue */}
                                <Box bgGradient="linear(to-b, white 0%, #f8fafc 20%, #f1f8ff 60%, #f0f8fe 100%)" py={16}>
                                    <Container maxW="4xl" textAlign="center">
                                        <VStack spacing={16}>
                                            {!isMobile ?
                                                <HStack spacing={16}>
                                                    <Text fontSize="3xl" color="orange.500" fontWeight="bold" fontStyle="italic">
                                                        "Honeybear is a lifesaver I can't help but praise!"
                                                    </Text>
                                                    <Text fontSize="3xl" color="orange.500" fontWeight="bold" fontStyle="italic">
                                                        "I save hours and hours every week with Honeybear."
                                                    </Text>
                                                </HStack> :
                                                <VStack spacing={16}>
                                                    <Text fontSize="3xl" color="orange.500" fontWeight="bold" fontStyle="italic">
                                                        "Honeybear is a lifesaver I can't help but praise!"
                                                    </Text>
                                                    <Text fontSize="3xl" color="orange.500" fontWeight="bold" fontStyle="italic">
                                                        "I save hours and hours every week with Honeybear."
                                                    </Text>
                                                </VStack>}

                                            <Box w="full" maxW="5xl">
                                                <Box
                                                    bg="white"
                                                    border="2px"
                                                    borderColor="#2563eb"
                                                    borderRadius="full"
                                                    py={6}
                                                    px={7}
                                                    display="flex"
                                                    alignItems="center"
                                                    minH="60px"
                                                >
                                                    {!isMobile ?
                                                    <TypingAnimation phrases={phrases}/> :
                                                        <Text
                                                            fontSize={!isMobile ? 'lg' : 'md'} // Customizable font size
                                                            bgGradient="linear(to-r, #2563eb, #7c3aed)" // Gradient text styling
                                                            bgClip="text"
                                                            fontWeight="semibold"
                                                            whiteSpace="nowrap" // Prevents text wrapping
                                                        >
                                                            What are the key points in this document?
                                                        </Text>}
                                                </Box>
                                            </Box>
                                        </VStack>
                                    </Container>
                                </Box>

                                {/* Audio/Video Section - White */}
                                <Box bg="white" py={16}>
                                    <Container maxW="6xl">
                                        <Flex
                                            direction={{ base: "column", lg: "row" }}
                                            justify={{ base: "center", lg: "space-between" }}
                                            align={{ base: "center", lg: "center" }}
                                            gap={{ base: 12, lg: 0 }}
                                        >
                                            <VStack spacing={6} align={{ base: 'center', lg: 'start' }} maxW={{ base: "100%", lg: "45%" }}>
                                                <Heading size="2xl" color="#1e293b" fontWeight="bold" textAlign={{ base: "center", lg: "left" }}>
                                                    Work with Videos
                                                </Heading>
                                                <Text color="#64748b" fontSize="xl" lineHeight="1.6" textAlign={{ base: "center", lg: "left" }}>
                                                    Tired of long videos and struggling to find key content? Upload any YouTube link or video file,
                                                    and summarize and chat with it. Gives timestamp citations so you know exactly where the information is.
                                                </Text>
                                                <Button
                                                    borderRadius={16}
                                                    mt={2}
                                                    px={isMobile ? 6 : 7}
                                                    py={isMobile ? 6 : 7}
                                                    fontSize={isMobile ? 18 : 22}
                                                    colorScheme={'orange'}
                                                    bgGradient="linear(to-r, orange.400, orange.500)"
                                                    _hover={{
                                                        bgGradient: "linear(to-r, orange.400, orange.600)",
                                                        boxShadow: 'lg'
                                                    }}
                                                    onClick={() => {
                                                        if (auth.isLoggedIn) {
                                                            fileInput.current.click();
                                                        } else {
                                                            onOpenSignUpScreen1();
                                                        }
                                                    }}>
                                                    {auth.isLoggedIn ? t('Upload') : t('Get started')}
                                                </Button>
                                            </VStack>

                                            <Box
                                                position="relative"
                                                width="280px"
                                                height="240px"
                                                flexShrink={0}
                                            >
                                                {/* Headphones Icon - Top Left */}
                                                <Box
                                                    position="absolute"
                                                    top="0"
                                                    left="0"
                                                    width="100px"
                                                    height="100px"
                                                    bg="linear-gradient(135deg, #1e3a8a, #3b82f6)"
                                                    borderRadius="16px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    boxShadow="0 20px 40px rgba(30, 58, 138, 0.3), 0 10px 20px rgba(0, 0, 0, 0.1)"
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _hover={{
                                                        transform: "translateY(-8px) scale(1.05)",
                                                        boxShadow: "0 30px 60px rgba(30, 58, 138, 0.4), 0 15px 30px rgba(0, 0, 0, 0.15)"
                                                    }}
                                                    zIndex={4}
                                                >
                                                    <FiHeadphones size={40} color={'white'} />
                                                </Box>

                                                {/* Music Notes Icon - Top Right */}
                                                <Box
                                                    position="absolute"
                                                    top="30px"
                                                    right="40px"
                                                    width="100px"
                                                    height="100px"
                                                    bg="linear-gradient(135deg, #e0e7ff, #c7d2fe)"
                                                    borderRadius="16px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    boxShadow="0 15px 35px rgba(99, 102, 241, 0.2), 0 8px 16px rgba(0, 0, 0, 0.1)"
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _hover={{
                                                        transform: "translateY(-6px) scale(1.05)",
                                                        boxShadow: "0 25px 50px rgba(99, 102, 241, 0.3), 0 12px 24px rgba(0, 0, 0, 0.15)"
                                                    }}
                                                    border="1px solid rgba(255, 255, 255, 0.3)"
                                                    zIndex={3}
                                                >
                                                    <FiMusic size={40} />
                                                </Box>

                                                {/* Video Camera Icon - Bottom Left */}
                                                <Box
                                                    position="absolute"
                                                    bottom="30px"
                                                    left="30px"
                                                    width="100px"
                                                    height="100px"
                                                    bg="white"
                                                    borderRadius="16px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    boxShadow="0 18px 38px rgba(0, 0, 0, 0.12), 0 8px 20px rgba(0, 0, 0, 0.08)"
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _hover={{
                                                        transform: "translateY(-7px) scale(1.05)",
                                                        boxShadow: "0 28px 58px rgba(0, 0, 0, 0.18), 0 12px 30px rgba(0, 0, 0, 0.12)"
                                                    }}
                                                    border="1px solid rgba(30, 58, 138, 0.1)"
                                                    zIndex={2}
                                                >
                                                    <FiVideo size={40} />
                                                </Box>

                                                {/* PDF File Icon - Bottom Right */}
                                                <Box
                                                    position="absolute"
                                                    bottom="0"
                                                    right="30px"
                                                    width="100px"
                                                    height="100px"
                                                    bg="linear-gradient(135deg, #dc2626, #ef4444)"
                                                    borderRadius="16px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    boxShadow="0 16px 32px rgba(220, 38, 38, 0.3), 0 8px 16px rgba(0, 0, 0, 0.1)"
                                                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                                    _hover={{
                                                        transform: "translateY(-6px) scale(1.05)",
                                                        boxShadow: "0 26px 52px rgba(220, 38, 38, 0.4), 0 12px 24px rgba(0, 0, 0, 0.15)"
                                                    }}
                                                    zIndex={1}
                                                >
                                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="white">
                                                        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                                                        <text x="12" y="16" textAnchor="middle" fontSize="5" fill="white" fontWeight="bold">PDF</text>
                                                    </svg>
                                                </Box>
                                            </Box>
                                        </Flex>
                                    </Container>
                                </Box>

                                {/* Welcome Section - Light Blue */}
                                <Box justify={'center'} align={'center'} mt={'5rem'} mb={'2rem'}
                                     display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Box
                                        width={['100%','89%', '81%', '73%', '64%']}
                                        borderRadius={!isMobile ? 20 : 0}
                                        overflow="hidden"
                                        position="relative"
                                        transform="translateY(0)"
                                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                        _hover={{
                                            transform: "translateY(-8px)",
                                            boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                                        }}
                                        boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                                        _before={{
                                            content: '""',
                                            position: 'absolute',
                                            top: '-2px',
                                            left: '-2px',
                                            right: '-2px',
                                            bottom: '-2px',
                                            background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                            borderRadius: !isMobile ? 22 : 2,
                                            zIndex: -1,
                                            opacity: 0.8
                                        }}
                                        _after={{
                                            content: '""',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                            borderRadius: !isMobile ? 20 : 0,
                                            pointerEvents: 'none',
                                            zIndex: 1
                                        }}>

                                        <LazyLoad height={'auto'} width={'100%'} offset={100}>
                                            <Image src={process.env.PUBLIC_URL + '/3_screenshot.gif'} alt={"video gif"} width={'100%'} borderRadius={19} height={'auto'} style={{
                                                position: 'relative',
                                                zIndex: 2
                                            }}/>
                                        </LazyLoad>
                                    </Box>
                                </Box>


                                {/* FAQ Section - White */}
                                <FAQ2/>

                                {/* Bottom CTA - Dark Blue */}
                                <Box bg="#1e293b" py={16}>
                                    <Container maxW="4xl" textAlign="center">
                                        <VStack spacing={6}>
                                            <Text color="#94a3b8" textTransform="uppercase" letterSpacing="wide" fontSize="sm" fontWeight="medium">
                                                IMPROVE YOUR PRODUCTIVITY
                                            </Text>
                                            <Heading size="2xl" color="white" fontWeight="bold">
                                                Save 9+ Hours/Week
                                            </Heading>
                                            <Text color="lightgray" fontSize="lg" maxW="2xl" fontWeight={500}>
                                                29% of users in a recent survey reported that Honeybear.ai saves them 9-14 hours every week.
                                            </Text>
                                            <Button
                                                borderRadius={16}
                                                px={isMobile ? 6 : 7}
                                                py={isMobile ? 6 : 7}
                                                fontSize={isMobile ? 18 : 22}
                                                colorScheme={'orange'}
                                                bgGradient="linear(to-r, orange.400, orange.500)"
                                                _hover={{
                                                    bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                    boxShadow: 'lg' // Adds a slight shadow on hover
                                                }}
                                                onClick={() => {
                                                    if (auth.isLoggedIn) {
                                                        fileInput.current.click();
                                                    } else {
                                                        onOpenSignUpScreen1();
                                                    }
                                                }}>
                                                Try for Free
                                            </Button>
                                            {/*<Button*/}
                                            {/*    bg="white"*/}
                                            {/*    color="#1e293b"*/}
                                            {/*    size="lg"*/}
                                            {/*    px={8}*/}
                                            {/*    py={6}*/}
                                            {/*    fontSize="lg"*/}
                                            {/*    borderRadius="lg"*/}
                                            {/*    _hover={{ bg: "#f8fafc" }}*/}
                                            {/*    fontWeight="600"*/}
                                            {/*>*/}
                                            {/*    Start for Free*/}
                                            {/*</Button>*/}
                                        </VStack>
                                    </Container>
                                </Box>

                                {/* Footer - White */}
                                {/*<LargeWithNewsletter />*/}
                            </Box>
                        ) : (
                            renderTabContent()
                        )
                    }
                </VStack>
            </FullScreenTemplateHomePage>
            <Box height={"8rem"}/>
            {auth.isLoggedIn ? 
            <LargeWithNewsletter/> : <LargeWithNewsletter backColor="white"/>}
            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1} onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1} onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <ScanModal1 isOpenScanModal1={isOpenScanModal1} onCloseScanModal1={onCloseScanModal1} onOpenScanModal1={onOpenScanModal1}/>
            <ScanModalIntro1 isOpenScanModalIntro1={isOpenScanModalIntro1} onCloseScanModalIntro1={onCloseScanModalIntro1}
                             onOpenScanModalIntro1={onOpenScanModalIntro1}/>
            <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                           onClosePricingScreen={onClosePricingScreen}
                           onOpenPricingScreen={onOpenPricingScreen}/>
        </div>
    );
};

export default NewUnifiedHomePage;







